<template>
  <div class="DataTabulate">
    <!-- 内容 -->
    <div class="content">
      <div class="content-item box1">
        <div class="itemText">总设备数</div>
        <div class="quantity">{{ todayStat }}</div>
      </div>
      <div class="content-item box2">
        <div class="itemText">开启数量</div>
        <div class="quantity">{{ yesterdayStat }}</div>
      </div>
      <div class="content-item box3">
        <div class="itemText">关闭数量</div>
        <div class="quantity">{{ weekStat }}</div>
      </div>
      <div class="content-item box4">
        <div class="itemText">故障数量</div>
        <div class="quantity">{{ 0 }}</div>
      </div>
    </div>
  </div>
</template>


<script>
import { statistics,findIndexDeviceTab,findIndexLevel } from "api/home"
export default {
  name: "DataTabulate",
  data(){
    return {
      todayStat: 0,
      yesterdayStat: 0,
      weekStat: 0,
      monthStat: 0,
      AStat: 0,
      BStat: 0,
      CStat: 0,
      DStat: 0,
    }
  },
  created() {
    // this.getStatData(1 , "DAY");
    // this.getStatData(0 , "DAY");
    // this.getStatData(7 , "WEEK");
    // this.getStatData(365 , "YEAR");
    // this.findIndexDeviceTab();
    // this.findIndexLevel();
  },
  methods: {
    /**
     * 逻辑区
     */


    /**
     * 接口区
     */
    //今日
    getStatData(interval, timeType) {
      statistics(interval, timeType)
      .then(res => {
        if(timeType == "DAY" && interval == 0) {
          this.todayStat = res.data == null ? 0 : res.data.deviceNumbers;
        } else if(timeType == "DAY" && interval == 1) {
          this.yesterdayStat = res.data == null ? 0 : res.data.deviceNumbers;
        } else if(timeType == "WEEK") {
          this.weekStat = res.data == null ? 0 : res.data.deviceNumbers
        } else if(timeType == "YEAR") {
          this.monthStat = res.data == null ? 0 : res.data.deviceNumbers
        }
      })
      .catch(err => {
        console.log(err)
      });
    },
    findIndexDeviceTab(){
      findIndexDeviceTab()
        .then(res => {
          this.todayStat = res.data == null ? 0 : res.data.todayStat;
          this.yesterdayStat = res.data == null ? 0 : res.data.yesterdayStat;
          this.weekStat = res.data == null ? 0 : res.data.weekStat
          this.monthStat = res.data == null ? 0 : res.data.monthStat
        })
        .catch(err => {
          console.log(err)
        });
    },
    findIndexLevel(){
      findIndexLevel()
        .then(res => {
          console.log(res);
          this.AStat = res.data == null ? 0 : res.data.astat;
          this.BStat = res.data == null ? 0 : res.data.bstat;
          this.CStat = res.data == null ? 0 : res.data.cstat;
          this.DStat = res.data == null ? 0 : res.data.dstat;
        })
        .catch(err => {
          console.log(err)
        });
    },
  }

}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 30px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  &-item {
    flex: 1;
    margin-left: 30px;
    height: 174px;
    border-radius: 10px;

    text-align: center;
    .quantity {
      line-height: 150px;
      font-size: 48px;
    }
    .itemText {
      width: 170px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #171515;
      line-height: 100px;
      margin: 0 auto;
    }
  }
  &-item:first-child {
    margin-left: 0
  }
}
.btn {
  width: 144px;
  height: 33px;
  background-color: red;
}
.box1 {
  background: linear-gradient(137deg, #FCB69F 0%, #FFECD2 100%);
}
.box2 {
  background: linear-gradient(137deg, #FF9A9E 0%, #FECFEF 100%);
}
.box3 {
  background: linear-gradient(137deg, #FDCBF1 0%, #FECFEF 100%);
}
.box4 {
  background: linear-gradient(137deg, #A1C4FD 0%, #C2E9FB 100%);
}
</style>
